import axios from 'axios';
import { apiModule } from '@/helpers/utils';
const adminPrefix = apiModule.ADMINISTRATION;
const inboxPrefix = apiModule.INBOX;
const requestsPrefix = apiModule.REQUESTS;
const systemPrefix = apiModule.SYSTEM;
const dashboardPrefix = window.location.origin + '';

export default {
  getQaimConfig: () => axios.get('../config.prod.json'),
  getUserInfo: () => axios.get(`${adminPrefix}/user/GetUserInfo`),
  getCaseType: caseTypeId => axios.get(`${adminPrefix}/cases-types/${caseTypeId}`),
  getCaseCategory: caseCategoryId => axios.get(`${adminPrefix}/case-categories/${caseCategoryId}`),
  getSideNavItems: () => axios.get(`${inboxPrefix}/menu`),
  getDataGridConfigurations: id => axios.get(`${inboxPrefix}/grids/${id}/configurations`),
  getPickLists: () => axios.get(`${inboxPrefix}/pick-lists`),
  getDataGridItems: (endPointUrl, searchQuery, cancelCallback = () => { }) =>
    axios.get(
      endPointUrl,
      { params: searchQuery },
      { cancelToken: new axios.CancelToken(cancelCallback) }
    ),
  getDashboardChartData: ({ endpoint, searchQuery }) =>
    axios.get(`${requestsPrefix}${endpoint}`, { params: searchQuery }),
  getDashboardUserInfo: () => axios.get(`${dashboardPrefix}/api/UserInfo`),
  getDashboards: () => axios.get(`${inboxPrefix}/dashboards`),
  getDynamicForms: () => axios.get(`${inboxPrefix}/forms`),
  addDynamicForm: payload => axios.post(`${inboxPrefix}/forms`, payload),
  getDynamicForm: id => axios.get(`${inboxPrefix}/forms/${id}`),
  getDynamicFormFields: id => axios.get(`${inboxPrefix}/forms/${id}/fields`),
  editDynamicForm: (payload, id) => axios.put(`${inboxPrefix}/forms/${id}`, payload),
  getDynamicGrids: () => axios.get(`${inboxPrefix}/grids`),
  getDynamicGridsHasForms: () => axios.get(`${inboxPrefix}/grids?isFormRelated=true`),
  getDynamicGrid: id => axios.get(`${inboxPrefix}/grids/${id}`),
  addDynamicGrid: payload => axios.post(`${inboxPrefix}/grids`, payload),
  getRequests: query => axios.get(`${requestsPrefix}/lawsuit-requests/my-requests`, { params: query }),
  getCaseTypeRequestTypes: caseTypeId => axios.get(`${adminPrefix}/cases-types/${caseTypeId}/request-types`),
  getDeceasedAndHeirsData: ({ requestCode, socialId }) => axios.get(`${systemPrefix}/inhaat-inquiry/heirs/01/${requestCode}/${socialId}`),
  getDeceasedAndHeirsDataForDefendant: ({ socialId }) => axios.get(`${systemPrefix}/inhaat-inquiry/heirs/${socialId}`),
  getRealEstateDeedInfo: ({ deedId, deedDate }) => axios.get(`${systemPrefix}/real-estate-deed/${deedId}/date/${deedDate}`),
  getRealEstateDeedsInfoByOwnerId: ownerId => axios.get(`${systemPrefix}/real-estate-deeds/${ownerId}`),
  getRealEstateContractDetails: ({ contractNumber, partySocialId, versionNumber }) => axios.get(`${systemPrefix}/real-estate/contract-details/${contractNumber}?partySocialId=${partySocialId}&versionNumber=${versionNumber}`),
  getNafathOtp: payload => axios.post(`${systemPrefix}/nafath/get-otp`, payload),
  checkNafathOtpStatus: payload => axios.post(`${systemPrefix}/nafath/check-status`, payload),
  getRecaptchaConfig: () => axios.get('../config.prod.json'),

};
